// extracted by mini-css-extract-plugin
export var productCell = "SLI4HdPVrKEy4m3sKbI1";
export var productCellTitle = "Toc0RvbXViTraHub30dU";